import { render, staticRenderFns } from "./SaleUserSelect.vue?vue&type=template&id=ec7a82bc"
import script from "./SaleUserSelect.vue?vue&type=script&lang=js"
export * from "./SaleUserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports